import { useImpactPageData } from '#src/app/pages/about/impact/pageContext';

type Result = ModelHookResult<{
	totalUserCount: number;
	totalUserCountLocalized: string;
}>;

export function useUserCount(): Result {
	const {
		data: {
			totalUserCount: { total, totalLocalized },
		},
	} = useImpactPageData();

	return {
		data: { totalUserCount: total, totalUserCountLocalized: totalLocalized },
	};
}
